import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Col, Row } from 'antd';

const Title = styled.p`
  margin-bottom: 5px;
`;

const SubTitle = styled.span`
  font-weight: bold;
  margin-right: 5px;
`;

const TitleInfo = styled.span``;

const Wrapper = styled.div`
  margin-top: 10px;
`;

const Form = styled.div`
`;

const HeaderInfo = ({
  intl,
  multiLineIds,
  renderField,
}) =>
  <Wrapper>
    <Title>
      <SubTitle>
        {intl.formatMessage({ id: 'fileUpload.HEADER_INFORMATION' })}
      </SubTitle>
      <TitleInfo>
        ({intl.formatMessage({ id: 'fileUpload.ALL_ORDERS' }, { number: multiLineIds.length })})
      </TitleInfo>
    </Title>
    <Form>
      <Row>
        <Col span={12}>{renderField('customerName')}</Col>
        <Col span={12}>{renderField('customerNumber')}</Col>
      </Row>
      <Row>
        <Col span={12}>{renderField('installedAtName')}</Col>
        <Col span={12}>{renderField('installedAtNumber')}</Col>
      </Row>
      <Row>
        <Col span={12}>{renderField('poNumber')}</Col>
        <Col span={12}>{renderField('salesRepresentativeNumber')}</Col>
      </Row>
      <Row>
        <Col span={12}>{renderField('payerName')}</Col>
        <Col span={12}>{renderField('payerNumber')}</Col>
      </Row>
      <Row>
        <Col span={6}>{renderField('payerVat')}</Col>
        <Col span={6}>{renderField('quoteNumber')}</Col>
        <Col span={6}>{renderField('salesPrice')}</Col>
        <Col span={6}>{renderField('currency')}</Col>
      </Row>
      <Row>
        {/* totalFreight can be span 6 if there is a other field needed on this line*/}
        <Col span={12}>{renderField('totalFreight')}</Col>
        <Col span={12}>{renderField('incoTerm')}</Col>
      </Row>
    </Form>
  </Wrapper>;
HeaderInfo.propTypes = {
  intl: PropTypes.object,
  multiLineIds: PropTypes.array,
  renderField: PropTypes.func,
};

export default HeaderInfo;
